import './styles.scss';
import React, {useState} from 'react';
import UsersTable from "../../components/specific/Users.table/Users.table.component";
import {useQuery} from "react-query";
import UserApi from "../../api/User/User.api";
import DefaultLoader from "../../components/common/DefaultLoader/DefaultLoader";
import UserFilters from "../../components/specific/Users.filters/Users.filters";
import {Collapse, notification} from "antd";
import UsersFilterManager from "../../components/specific/Users.filters/Users.filters.manager";
import {UsersInviteTypes} from "../../components/specific/Users.invite/Users.invite.types";
import {ROLES, TOAST_DURATION} from "../../settings";
import UsersInviteFormAsButton from "../../components/specific/Users.invite/Users.invite.form.asButton";
import OfficersFiltersManager from "../../components/specific/Officers.filters/Officers.filters.manager";
import {SearchOutlined} from "@ant-design/icons";
import useUserStore from "../../data/User.store";


function UserReportsContainer() {
    const {user} = useUserStore();
    const [query, setQuery] = useState<any>(getLocalStorageQuery());
    const [page, setPage] = useState(1);
    const [collapsed, setCollapsed] = useState(OfficersFiltersManager.initialQuerySent);
    const {isLoading, data, refetch} = useQuery(['fetchUsers', query, page], UserApi.getUsers);

    async function onInviteSubmit(values) {
        let chosenRole = values[UsersInviteTypes.Role];
        let user;
        switch (chosenRole) {
            case ROLES.CLIENT:
                // Turn States of Business into a comma separated string to save as a text field in the database.
                if (values[UsersInviteTypes.StatesOfBusiness]) {
                    values[UsersInviteTypes.StatesOfBusiness] = values[UsersInviteTypes.StatesOfBusiness].join(",");
                }
                user = await UserApi.inviteClient(values);
                break;
            case ROLES.SALES:
                user = await UserApi.inviteSales(values);
                break;
            case ROLES.ADMIN:
                user = await UserApi.inviteAdmin(values);
                break;
        }
        if (user) {
            notification.success({
                message: 'Success!',
                description: <span>You have successfully invited {user.email}</span>,
                duration: TOAST_DURATION,
            })
            await refetch();
        } else {
            notification.error({
                message: 'Error inviting user',
                description: <span>User could not be invited. This is most likely because they already have an account.</span>,
                duration: TOAST_DURATION,
            })
        }

    }

    function onPagination(page: number) {
        setPage(page);
    }

    function getContent() {
        if (isLoading || !data?.records) {
            return (
                <div className='default-loader-full'>
                    <DefaultLoader text='Loading users...'/>
                </div>
            )
        } else {
            const pagination = {
                onChange: onPagination,
                pageSize: 25,
                total: Math.trunc(data.totalRecords),
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                current: page,
            }
            return (
                <div className='user-reports-container-content'>
                    <div className='user-reports-container-content-table'>
                        <UsersTable data={data.records} pagination={pagination} onChange={refetch}/>
                    </div>
                </div>
            )
        }
    }

    function onSubmitQuery(values: any) {
        let serializedQuery = UsersFilterManager
            .setDeserializedValues(values)
            .serializeQuery()
            .setQueryToLocalStorage()
            .setInitialQuerySent()
            .getValues();
        setQuery(serializedQuery);
        setCollapsed(true);
    }

    function getLocalStorageQuery() {
        return UsersFilterManager
            .getQueryFromLocalStorage()
            .getValues();
    }

    function getUsersFiltersInitialValues() {
        return UsersFilterManager
            .setSerializedValues(getLocalStorageQuery())
            .deserializeQuery()
            .getValues()
    }
    function onCollapseChange(keys){
        if (keys.indexOf("1") !== -1){
            setCollapsed(false);
        } else {
            setCollapsed(true);
        }
    }

    return (
        <div className='user-reports-container'>
            <div className='user-reports-container-header'>
                <div className='left'>
                    <div className='title'>
                        Users
                    </div>
                </div>
                <div className='right'>
                    {user.role.name === ROLES.ADMIN &&
                    <UsersInviteFormAsButton key='admin' inviteText='Invite User' onSubmit={onInviteSubmit}/>}
                </div>
            </div>
            <div className='filters'>
                <Collapse ghost activeKey={collapsed ? null : 1} onChange={onCollapseChange} expandIconPosition='right'>
                    <Collapse.Panel key={1} header={<div className='global-search-criteria-dropdown-header'><SearchOutlined/>Edit Search Criteria</div>}>
                        <UserFilters onSubmitQuery={onSubmitQuery}
                                     initialValues={getUsersFiltersInitialValues()}/>
                    </Collapse.Panel>
                </Collapse>
            </div>
            {getContent()}
        </div>
    )
}

export default UserReportsContainer;